import React, { FC, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Dealer, DealerId } from '@upstart/harmony/lib/legos/dealerTypes';
// @ts-ignore @TODO: add types for package
import Toggle from 'react-bootstrap-toggle';
import SidebarContainer from '../SidebarContainer';
import DealerNav from '../../components/DealerNav';
import LoadingOverlay from '../../components/LoadingOverlay';
import {
  dealerRequest,
  updateDealerRequest,
} from '../../redux/dealers/actions';
import ErrorMessage from '../../components/ErrorMessage';
import './InstoreForm.scss';
import { ChatPreference } from './ChatPreference';

interface MatchParams {
  dealerId: DealerId;
}

type Error = { status: number; error: string };

interface Props extends RouteComponentProps<MatchParams> {
  actions: {
    dealerRequest: ({ dealerId }: { dealerId: DealerId }) => void;
    updateDealerRequest: Function;
  };
  dealer?: Dealer;
  isFetching?: boolean;
  error?: Error | null;
}

const InstoreForm: FC<Props> = ({
  actions,
  dealer,
  isFetching = false,
  match,
  error,
}: Props) => {
  const { dealerId }: { dealerId: DealerId } = match.params;

  useEffect(() => {
    actions.dealerRequest({ dealerId });
  }, [actions, dealerId]);

  if (!dealerId) {
    return null;
  }

  const onInstoreEnableChange = (value: boolean) => {
    const newDealer = { id: dealerId, wizard: { enableInstore: value } };
    actions.updateDealerRequest({ dealer: newDealer, isDiffObject: true });
  };

  return (
    <SidebarContainer title={dealer?.name || 'Instore'} logo={dealer?.logo}>
      <div className="dealers-table">
        <DealerNav />
        {error && <ErrorMessage error={error} />}
        <LoadingOverlay active={isFetching}>
          <div className="dealer-editor-container instore-config-container">
            <div className="enable-instore">
              <div>Enable Upstart Instore</div>
              <Toggle
                size="sm"
                className="toggle-switch"
                active={!!dealer?.wizard?.enableInstore}
                onClick={onInstoreEnableChange}
              />
            </div>
            {!!dealer?.wizard?.enableInstore && (
              <ChatPreference
                dealer={dealer}
                updateDealerRequest={actions.updateDealerRequest}
              />
            )}
          </div>
        </LoadingOverlay>
      </div>
    </SidebarContainer>
  );
};

export interface Dealers {
  dealer: Dealer;
  fetching?: boolean;
  error?: Error | null;
}

const mapStateToProps = ({ dealers }: { dealers?: Dealers }) => ({
  dealer: dealers?.dealer,
  error: dealers?.error,
  isFetching: dealers?.fetching,
});

const mapDispatchToProps = (dispatch: Dispatch<{}>) => ({
  actions: bindActionCreators({ dealerRequest, updateDealerRequest }, dispatch),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(InstoreForm),
);
